// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import config from '../config';
// import 'react-toastify/dist/ReactToastify.css';
// import { Container, Typography, Box, TextField, Button, IconButton } from '@mui/material';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// const AddUser = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [companyName, setCompanyName] = useState('');
//   const [url, setUrl] = useState('');
//   const [photoLibraryLink, setPhotoLibraryLink] = useState('');
//   const navigate = useNavigate();

//   const handleAddUser = async (e) => {
//     e.preventDefault();
//     const token = localStorage.getItem('adminToken');
//     if (!token) {
//       toast.error('You are not logged in.');
//       navigate('/admin/login');
//       return;
//     }

//     try {
//       const response = await fetch(`${config.backendUrl}/api/admin/users`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`
//         },
//         body: JSON.stringify({ username, password, companyName, url, photoLibraryLink }),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         toast.success('User added successfully!');
//         setUsername('');
//         setPassword('');
//         setCompanyName('');
//         setUrl('');
//         setPhotoLibraryLink('');
//       } else {
//         toast.error(`Error: ${data.message}`);
//       }
//     } catch (error) {
//       toast.error('An error occurred. Please try again.');
//     }
//   };

//   return (
//     <Container maxWidth="md">
//       <Box sx={{ marginTop: 8, marginBottom:5,  display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//         <IconButton onClick={() => navigate(-1)} sx={{ alignSelf: 'flex-start' }}>
//           <ArrowBackIcon />
//         </IconButton>
//         <Typography component="h1" variant="h5">
//           Add User
//         </Typography>
//         <Box
//           component="form"
//           onSubmit={handleAddUser}
//           sx={{
//             mt: 3,
//             maxHeight: '70vh', // Set max height for the form
//             overflowY: 'auto', // Enable vertical scrolling
//             width: '100%',
//           }}
//         >
//           <TextField
//             variant="outlined"
//             margin="normal"
//             required
//             fullWidth
//             id="username"
//             label="Username"
//             name="username"
//             autoComplete="username"
//             autoFocus
//             value={username}
//             onChange={(e) => setUsername(e.target.value)}
//           />
//           <TextField
//             variant="outlined"
//             margin="normal"
//             required
//             fullWidth
//             name="password"
//             label="Password"
//             type="password"
//             id="password"
//             autoComplete="current-password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//           />
//           <TextField
//             variant="outlined"
//             margin="normal"
//             required
//             fullWidth
//             name="companyName"
//             label="Company Name"
//             id="companyName"
//             value={companyName}
//             onChange={(e) => setCompanyName(e.target.value)}
//           />
//           <TextField
//             variant="outlined"
//             margin="normal"
//             required
//             fullWidth
//             name="url"
//             label="URL"
//             id="url"
//             value={url}
//             onChange={(e) => setUrl(e.target.value)}
//           />
//           <TextField
//             variant="outlined"
//             margin="normal"
//             required
//             fullWidth
//             name="photoLibraryLink"
//             label="Photo Library Link"
//             id="photoLibraryLink"
//             value={photoLibraryLink}
//             onChange={(e) => setPhotoLibraryLink(e.target.value)}
//           />
//           <Button
//             type="submit"
//             fullWidth
//             variant="contained"
//             color="primary"
//             sx={{ mt: 3, mb: 2 }}
//           >
//             Add User
//           </Button>
//         </Box>
//       </Box>
//     </Container>
//   );
// };

// export default AddUser;


import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import config from '../config';
import 'react-toastify/dist/ReactToastify.css';
import { Container, Typography, Box, TextField, Button, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const AddUser = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [url, setUrl] = useState('');
  const [photoLibraryLink, setPhotoLibraryLink] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState('');
  const navigate = useNavigate();

  const handleAddUser = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('adminToken');
    if (!token) {
      toast.error('You are not logged in.');
      navigate('/admin/login');
      return;
    }
  
    // Create a new FormData instance
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    formData.append('companyName', companyName);
    formData.append('url', url);
    formData.append('photoLibraryLink', photoLibraryLink);
  
    // Append the selected image if available
    if (selectedImage) {
      formData.append('photo', selectedImage); // 'photo' should match the field name in backend
    }
  
    try {
      const response = await fetch(`${config.backendUrl}/api/admin/users`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData, // Use FormData here instead of JSON
      });
  
      const data = await response.json();
      if (response.ok) {
        toast.success('User added successfully!');
        setUsername('');
        setPassword('');
        setCompanyName('');
        setUrl('');
        setPhotoLibraryLink('');
        setSelectedImage(null);
        setImagePreviewUrl('');
      } else {
        toast.error(`Error: ${data.message}`);
      }
    } catch (error) {
      toast.error('An error occurred. Please try again.');
    }
  };
  
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setSelectedImage(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ marginTop: 8, marginBottom: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <IconButton onClick={() => navigate(-1)} sx={{ alignSelf: 'flex-start' }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography component="h1" variant="h5">
          Add User
        </Typography>
        <Box
          component="form"
          onSubmit={handleAddUser}
          sx={{
            mt: 3,
            maxHeight: '70vh',
            overflowY: 'auto',
            width: '100%',
          }}
        >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoComplete="username"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="companyName"
            label="Company Name"
            id="companyName"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="url"
            label="URL"
            id="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="photoLibraryLink"
            label="Photo Library Link"
            id="photoLibraryLink"
            value={photoLibraryLink}
            onChange={(e) => setPhotoLibraryLink(e.target.value)}
          />

          <Box sx={{ mt: 2 }}>
            <Typography variant="body1" gutterBottom>
              Upload Image (optional)
            </Typography>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ marginBottom: '10px' }}
            />
            {imagePreviewUrl && (
              <Box sx={{ mt: 1 }}>
                <img
                  src={imagePreviewUrl}
                  alt="Selected"
                  style={{ maxWidth: '100%', height: 'auto', border: '1px solid #ccc', padding: '5px' }}
                />
              </Box>
            )}
          </Box>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }}
          >
            Add User
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default AddUser;
